import React from "react";
import {
    Accordion,
    Alert,
    Flex,
    InfoIcon,
    Loader,
    Text,
} from "@fluentui/react-northstar";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

import { _api_get_model } from "../../api";

export const ContentImportTemplates = ({
    isLoading = false,
    formatedTemplatesJson = [],
}) => {
    const { t } = useTranslation("translation");

    return (
        <Flex column gap="gap.medium" styles={{ marginTop: "10px" }}>
            <Flex column gap="gap.medium">
                <Text
                    content={t(
                        "pages.add_employee.step_tasks.dialog.description"
                    )}
                />
                <Alert
                    icon={<InfoIcon />}
                    content={
                        <Text
                            styles={{ fontWeight: "600" }}
                            content={t(
                                "pages.add_employee.step_tasks.dialog.alert"
                            )}
                        />
                    }
                />
            </Flex>
            <Flex column>
                {isLoading ? (
                    <Loader label="Chargement des données !" />
                ) : formatedTemplatesJson?.length === 0 ? (
                    <Text
                        styles={{ fontWeight: "600" }}
                        content={"Aucun modèle de tâche trouvé !"}
                    />
                ) : (
                    <AccordionStyle
                        panels={formatedTemplatesJson}
                        key={"accordion"}
                    />
                )}
            </Flex>
        </Flex>
    );
};

export const AccordionStyle = styled(Accordion)`
    .ui-accordion__title {
        padding-bottom: 0px;
    }
    .Accordion__checkbox--header {
        padding-bottom: 10px;
    }
    .ui-accordion__title__content-wrapper > .ui-box {
        background-repeat: no-repeat;
        /* background-position-y: 5px; */
    }
    .ui-accordion__title__content-wrapper {
        background-color: #e8ebfa;
    }
`;
